module.exports = __webpack_public_path__ + "img/26-s.e3ba967b.png";